import type { SuppressionReason } from '@/api/types'

/**
 * Suppression reason labels. A plain module (no components) so routes can use
 * it in validateSearch without pulling dialogs into the main chunk.
 */
export const REASONS: Record<SuppressionReason, { label: string; description: string }> = {
  manual: { label: 'Manual', description: 'Added by an admin.' },
  unsubscribe: { label: 'Unsubscribed', description: 'The recipient asked not to be emailed.' },
  hard_bounce: { label: 'Hard bounce', description: 'The address doesn’t exist.' },
  complaint: { label: 'Complaint', description: 'The recipient marked a message as spam.' },
}
